"use client";

import { CategorySinglePageContext } from "@/helpers/contexts/CategorySinglePageContext";
import { countBreadcrumbs } from "@/helpers/common";
import { TCategoryPage } from "@/components/pages/translations/TCategoryPage";

export const TranslationCategoryPage = ({
  category,
  subcategoriesSlugs,
  breadcrumbsList,
  pagination,
  notFound,
  search,
  showSubcategory = true,
}: any) => (
  <CategorySinglePageContext.Provider
    value={{
      category: category as any,
      subcategoriesSlugs,
      breadcrumbsList: countBreadcrumbs(breadcrumbsList),
      pagination: pagination,
    }}
  >
    <TCategoryPage showSubcategory={showSubcategory} notFound={notFound} search={search} />
  </CategorySinglePageContext.Provider>
);
